export default "__VITE_ASSET__4e4a679f__"